module.exports = __webpack_public_path__ + "img/mv.510b765a.svg";